import React from "react";
import { useDialog } from "./useDialog";
import { backdropClose } from "./backdrop";

interface ModalProps {
  onClose: () => void;
  zIndex?: number;
  bg?: string;
  children: React.ReactNode;
}

export function Modal({ onClose, zIndex = 200, bg = "var(--overlay)", children }: ModalProps) {
  const dialogRef = useDialog(onClose);
  return (
    <div
      {...backdropClose(() => { onClose(); })}
      style={{ position: "fixed", inset: 0, background: bg, display: "flex", alignItems: "center", justifyContent: "center", zIndex }}
    >
      <div ref={dialogRef} role="dialog" aria-modal="true" tabIndex={-1} style={{ outline: "none", maxWidth: "calc(100vw - 32px)", maxHeight: "calc(100vh - 32px)", display: "flex", animation: "panel-in 0.18s var(--ease-out-quint)" }}>
        {children}
      </div>
    </div>
  );
}
